"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4800],{

/***/ 16612:
/***/ (function(module) {


var URL_PREFIXES = {
    LP: "/lp/",
    FREE_TIER: "/ft/",
    SEO: "/s/",
    TEMPLATES: "/templates/",
    GO_TEMPLATES: "/go-templates/",
    TERMS: "/terms/",
    SECURITY: "/security/",
    PARTNERS: "/partners/",
    CS: "/cs/",
    INTEGRATIONS: "/integrations/",
    PODCASTS: "/pod/",
    VISION: "/vision/",
    LANG: "/lang/",
    EMAILS: "/emails/",
    HR: "/hr/",
    TEST: "/test/",
    DEVELOPERS: "/developers/",
    REFLECT: "/reflect/"
};
module.exports = {
    URL_PREFIXES: URL_PREFIXES
};


/***/ }),

/***/ 65832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AUTO": function() { return /* binding */ AUTO; },
/* harmony export */   "BEST": function() { return /* binding */ BEST; },
/* harmony export */   "ECO": function() { return /* binding */ ECO; },
/* harmony export */   "GOOD": function() { return /* binding */ GOOD; },
/* harmony export */   "LOW": function() { return /* binding */ LOW; }
/* harmony export */ });
var AUTO = "q_auto";
var BEST = "q_auto:best";
var GOOD = "q_auto:good";
var ECO = "q_auto:eco";
var LOW = "q_auto:low";


/***/ }),

/***/ 5792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dj": function() { return /* binding */ SET_CLUSTER_FROM_PAGE_CONFIG_REASON; },
/* harmony export */   "ZD": function() { return /* binding */ PAGE_CONFIG; },
/* harmony export */   "ar": function() { return /* binding */ HP_COOKIE; },
/* harmony export */   "cv": function() { return /* binding */ SET_CLUSTER_FROM_SIGNUP_BUTTON_REASON; },
/* harmony export */   "kh": function() { return /* binding */ PLATFORM_COOKIE; },
/* harmony export */   "sL": function() { return /* binding */ HP_SIGNUP_BUTTON; },
/* harmony export */   "xf": function() { return /* binding */ PARAM; }
/* harmony export */ });
var PARAM = "hp_param";
var PAGE_CONFIG = "hp_page_config";
var HP_COOKIE = "hp_cookie";
var PLATFORM_COOKIE = "platform_cookie";
var HP_SIGNUP_BUTTON = "hp_signup_button";
//reasons
var SET_CLUSTER_FROM_PAGE_CONFIG_REASON = "set_cluster_from_page_config";
var SET_CLUSTER_FROM_SIGNUP_BUTTON_REASON = "set_cluster_from_signup_button";


/***/ }),

/***/ 10945:
/***/ (function(module) {


var CLUSTER_TYPE = "cluster";
var USE_CASE_TYPE = "use-case";
module.exports = {
    CLUSTER_TYPE: CLUSTER_TYPE,
    USE_CASE_TYPE: USE_CASE_TYPE
};


/***/ }),

/***/ 50663:
/***/ (function(module, exports) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CLUSTERS: function() {
        return CLUSTERS;
    },
    UTM_ADGROUP: function() {
        return UTM_ADGROUP;
    },
    UTM_BANNER: function() {
        return UTM_BANNER;
    },
    UTM_CAMPAIGN: function() {
        return UTM_CAMPAIGN;
    },
    UTM_KEYWORD: function() {
        return UTM_KEYWORD;
    },
    UTM_MEDIUM: function() {
        return UTM_MEDIUM;
    },
    UTM_SOURCE: function() {
        return UTM_SOURCE;
    },
    SIGNUP_REFERRER: function() {
        return SIGNUP_REFERRER;
    },
    LANDING_PAGE: function() {
        return LANDING_PAGE;
    }
});
var CLUSTERS = "clusters";
var UTM_ADGROUP = "utm_adgroup";
var UTM_BANNER = "utm_banner";
var UTM_CAMPAIGN = "utm_campaign";
var UTM_KEYWORD = "utm_keyword";
var UTM_MEDIUM = "utm_medium";
var UTM_SOURCE = "utm_source";
var SIGNUP_REFERRER = "signup_referrer";
var LANDING_PAGE = "landing_page";
module.exports = {
    CLUSTERS: CLUSTERS,
    UTM_ADGROUP: UTM_ADGROUP,
    UTM_BANNER: UTM_BANNER,
    UTM_CAMPAIGN: UTM_CAMPAIGN,
    UTM_KEYWORD: UTM_KEYWORD,
    UTM_MEDIUM: UTM_MEDIUM,
    UTM_SOURCE: UTM_SOURCE,
    SIGNUP_REFERRER: SIGNUP_REFERRER,
    LANDING_PAGE: LANDING_PAGE
};


/***/ }),

/***/ 55674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F3": function() { return /* binding */ FREE_TIER_2021_SEATS_LIMIT; },
/* harmony export */   "F_": function() { return /* binding */ NUM_DEFAULT_DISPLAYED_PLANS; },
/* harmony export */   "Iy": function() { return /* binding */ TIERS; },
/* harmony export */   "Jb": function() { return /* binding */ PERIOD_TEXTS; },
/* harmony export */   "U1": function() { return /* binding */ FEATURES_IDS; },
/* harmony export */   "Us": function() { return /* binding */ PLAN_INFO_SEGMENT_NAME; },
/* harmony export */   "ck": function() { return /* binding */ SUPPORTED_CURRENCIES; },
/* harmony export */   "fY": function() { return /* binding */ MAX_TEAM_SIZE; },
/* harmony export */   "no": function() { return /* binding */ FREE_TIER_2022_SEATS_LIMIT; },
/* harmony export */   "yv": function() { return /* binding */ ORDERED_PERIOD_NAMES; },
/* harmony export */   "z5": function() { return /* binding */ PERIODS; }
/* harmony export */ });
/* unused harmony exports PLATFORM_PERIODS, STANDARD_DASHBOARDS_AMOUNT, PRO_DASHBOARDS_AMOUNT */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var TIERS = {
    FREE: "free",
    BASIC: "basic",
    STANDARD: "standard",
    PRO: "pro",
    ENTERPRISE: "enterprise"
};
var PERIODS = {
    yearly: "yearly",
    monthly: "monthly"
};
var _obj;
var PLATFORM_PERIODS = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PERIODS.yearly, "YearlyPlan"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PERIODS.monthly, "MonthlyPlan"), _obj);
var _obj1;
var PERIOD_TEXTS = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, PERIODS.yearly, {
    billed: "pricingPage.periods.yearly.billed",
    displayName: "pricingPage.periods.yearly.displayName"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, PERIODS.monthly, {
    billed: "pricingPage.periods.monthly.billed",
    displayName: "pricingPage.periods.monthly.displayName"
}), _obj1);
var FEATURES_IDS = {
    STORAGE: "STORAGE"
};
var PLAN_INFO_SEGMENT_NAME = "PlanInfo";
var MAX_TEAM_SIZE = "200+";
var ORDERED_PERIOD_NAMES = [
    PERIODS.yearly,
    PERIODS.monthly
];
var STANDARD_DASHBOARDS_AMOUNT = 3;
var PRO_DASHBOARDS_AMOUNT = 10;
var NUM_DEFAULT_DISPLAYED_PLANS = 4;
var FREE_TIER_2021_SEATS_LIMIT = 2;
var FREE_TIER_2022_SEATS_LIMIT = 5;
var SUPPORTED_CURRENCIES = [
    {
        name: "usd",
        currencySign: "$",
        currencyShortText: "USD",
        shouldDisplayText: true
    },
    {
        name: "euro",
        currencySign: "€",
        currencyShortText: "EUR",
        shouldDisplayText: false
    },
    {
        name: "cad",
        currencySign: "$",
        currencyShortText: "CAD",
        shouldDisplayText: true
    },
    {
        name: "gbp",
        currencySign: "\xa3",
        currencyShortText: "GBP",
        shouldDisplayText: false
    },
    {
        name: "aud",
        currencySign: "$",
        currencyShortText: "AUD",
        shouldDisplayText: true
    },
    {
        name: "mxn",
        currencySign: "$",
        currencyShortText: "MXN",
        shouldDisplayText: true
    },
    {
        name: "brl",
        currencySign: "R$",
        currencyShortText: "BRL",
        shouldDisplayText: false
    },
    {
        name: "inr",
        currencySign: "₹",
        currencyShortText: "INR",
        shouldDisplayText: false
    },
    {
        name: "jpy",
        currencySign: "\xa5",
        currencyShortText: "JPY",
        shouldDisplayText: false
    }
];


/***/ }),

/***/ 54224:
/***/ (function(module) {


var CLUSTER = "cluster";
var SUB_CLUSTER = "subcluster";
var PREVENT_FREE_TIER_PARAM = "prevent_free_tier";
var SUPPORTED_OVERRIDE_QUERY_PARAMS = [
    CLUSTER,
    SUB_CLUSTER
];
var FORCE_PRICING = "force_pricing";
var FORCE_CURRENCY = "force-currency";
var DYNAMIC_ASSET_PARAM = "dimg";
var ACTIVE_TAB_ID = "ati";
var FROM_PARAM = "from";
module.exports = {
    CLUSTER: CLUSTER,
    SUB_CLUSTER: SUB_CLUSTER,
    PREVENT_FREE_TIER_PARAM: PREVENT_FREE_TIER_PARAM,
    SUPPORTED_OVERRIDE_QUERY_PARAMS: SUPPORTED_OVERRIDE_QUERY_PARAMS,
    FORCE_PRICING: FORCE_PRICING,
    FORCE_CURRENCY: FORCE_CURRENCY,
    DYNAMIC_ASSET_PARAM: DYNAMIC_ASSET_PARAM,
    ACTIVE_TAB_ID: ACTIVE_TAB_ID,
    FROM_PARAM: FROM_PARAM
};


/***/ }),

/***/ 42057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var COOKIES_POLICY_REQUIRED_COUNTRIES_ISO_CODES = (__webpack_require__(72632).COOKIES_POLICY_REQUIRED_COUNTRIES_ISO_CODES);
var CLOUDFRONT_MOBILE_HEADER = "cloudfront-is-mobile-viewer";
var CLOUDFRONT_TABLET_HEADER = "cloudfront-is-tablet-viewer";
var CLOUDFRONT_DESKTOP_HEADER = "cloudfront-is-desktop-viewer";
var CLOUDFRONT_COUNTRY_HEADER = "cloudfront-viewer-country";
var isMobileOrTablet = function(req) {
    return isMobile(req) || isTablet(req);
};
var isMobile = function(req) {
    var headers = req.headers;
    return headers[CLOUDFRONT_MOBILE_HEADER] && headers[CLOUDFRONT_MOBILE_HEADER] === "true";
};
var isTablet = function(req) {
    var headers = req.headers;
    return headers[CLOUDFRONT_TABLET_HEADER] && headers[CLOUDFRONT_TABLET_HEADER] === "true";
};
var isDesktop = function(req) {
    var headers = req.headers;
    return headers[CLOUDFRONT_DESKTOP_HEADER] && headers[CLOUDFRONT_DESKTOP_HEADER] === "true";
};
var isCookiesPolicyRequiredCountryFromServer = function(res) {
    var cloudFrontCountry = res.getHeader(CLOUDFRONT_COUNTRY_HEADER);
    return doesCountryRequireStrictCookiePolicy(cloudFrontCountry);
};
var doesCountryRequireStrictCookiePolicy = function(cloudFrontCountry) {
    return cloudFrontCountry && COOKIES_POLICY_REQUIRED_COUNTRIES_ISO_CODES.includes(cloudFrontCountry);
};
module.exports = {
    isMobileOrTablet: isMobileOrTablet,
    isDesktop: isDesktop,
    isMobile: isMobile,
    isTablet: isTablet,
    isCookiesPolicyRequiredCountryFromServer: isCookiesPolicyRequiredCountryFromServer,
    doesCountryRequireStrictCookiePolicy: doesCountryRequireStrictCookiePolicy
};


/***/ }),

/***/ 14688:
/***/ (function(module) {


var getFileExtension = function(filename) {
    if (!filename) return null;
    if (filename.indexOf(".") < 0) return null;
    return filename.split(".").pop().toLowerCase();
};
var removeFileExtension = function(filename) {
    if (filename.indexOf(".") < 0) return filename;
    return filename.substring(0, filename.lastIndexOf("."));
};
var replaceFileExtension = function(fileName, newExtension) {
    var pos = fileName.lastIndexOf(".");
    var untilPos = pos < 0 ? fileName.length : pos;
    return fileName.substring(0, untilPos) + ".".concat(newExtension);
};
module.exports = {
    getFileExtension: getFileExtension,
    replaceFileExtension: replaceFileExtension,
    removeFileExtension: removeFileExtension
};


/***/ }),

/***/ 77784:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var ref = __webpack_require__(85010), isCountryInContinent = ref.isCountryInContinent, OCEANIA = ref.OCEANIA;
var ref1 = __webpack_require__(13019), USE_OLD_STORAGE_SETTINGS = ref1.USE_OLD_STORAGE_SETTINGS, WEBSITE_AB_TEST_DEBUG_COOKIE_NAME = ref1.WEBSITE_AB_TEST_DEBUG_COOKIE_NAME;
var getAbTestVariantNew = (__webpack_require__(41871).getAbTestVariantNew);
var doesCountryRequireStrictCookiePolicy = (__webpack_require__(42057).doesCountryRequireStrictCookiePolicy);
var isRunningInClient = (__webpack_require__(44566).isRunningInClient);
var ref2 = __webpack_require__(60734), SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST = ref2.SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST, EXIT_POP_UP_SURVEY_AB_TEST = ref2.EXIT_POP_UP_SURVEY_AB_TEST, REVIVE_EXIT_POPUP_AB_TEST = ref2.REVIVE_EXIT_POPUP_AB_TEST, PERFORMANCE_STATIC_PAGE_AB_TEST = ref2.PERFORMANCE_STATIC_PAGE_AB_TEST, BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES = ref2.BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES, DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST = ref2.DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST, PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST = ref2.PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST, MOBILE_STICKY_SIGNUP_AB_TEST = ref2.MOBILE_STICKY_SIGNUP_AB_TEST, WELCOME_BACK_PAGE_TEST = ref2.WELCOME_BACK_PAGE_TEST, KEEP_REGION_TEST = ref2.KEEP_REGION_TEST, CONTACT_SALES_TYPEFORM_EMEA = ref2.CONTACT_SALES_TYPEFORM_EMEA, CONTACT_SALES_TYPEFORM_ANZ = ref2.CONTACT_SALES_TYPEFORM_ANZ, HEADER_NEW_PRODUCTS_OFFERING_TEST = ref2.HEADER_NEW_PRODUCTS_OFFERING_TEST, UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST = ref2.UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST, SHOW_SUCCESS_STORIES_IN_HEADER_TEST = ref2.SHOW_SUCCESS_STORIES_IN_HEADER_TEST, MOBILE_SOFT_SIGNUP_TEST = ref2.MOBILE_SOFT_SIGNUP_TEST, TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST = ref2.TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST, STUDIO_IN_HEADER_TEST = ref2.STUDIO_IN_HEADER_TEST, ENHANCED_PRODUCTS_IN_HEADER_TEST = ref2.ENHANCED_PRODUCTS_IN_HEADER_TEST, WM_HIGH_INTENT_EXPERIENCE = ref2.WM_HIGH_INTENT_EXPERIENCE, CONTACT_SALES_STICKY_BUTTON_EXPERIENCE = ref2.CONTACT_SALES_STICKY_BUTTON_EXPERIENCE, EXISTING_USERS_HEADER_PROMINANT_CONTACT_SALES_TEST = ref2.EXISTING_USERS_HEADER_PROMINANT_CONTACT_SALES_TEST, PROMINENT_CONTACT_SALES_IN_NEW_USERS_WEBSITE_PAGES_HEADER = ref2.PROMINENT_CONTACT_SALES_IN_NEW_USERS_WEBSITE_PAGES_HEADER, CRM_REMOVE_SALES_TEST = ref2.CRM_REMOVE_SALES_TEST, TALK_TO_SALES_TEST = ref2.TALK_TO_SALES_TEST, CONTACT_SALES_FOOTER_TEST = ref2.CONTACT_SALES_FOOTER_TEST;
var shouldGetSkipSignUpStepInPricingAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST, sendBigBrainEvent) === "new_with_skip";
};
var shouldSeeExitPopupSurveyAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 ? arguments[1] : void 0;
    return getAbTestVariantNew(abTests, EXIT_POP_UP_SURVEY_AB_TEST, sendBigBrainEvent) === "new_with_survey";
};
var shouldSeeReviveExitPopupAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, REVIVE_EXIT_POPUP_AB_TEST.test_name, sendBigBrainEvent) === REVIVE_EXIT_POPUP_AB_TEST.new_variation_name;
};
var shouldSeeStaticPagePerformanceAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cloudfrontViewerCountry = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (doesCountryRequireStrictCookiePolicy(cloudfrontViewerCountry)) return false;
    return getAbTestVariantNew(abTests, PERFORMANCE_STATIC_PAGE_AB_TEST.test_name, sendBigBrainEvent) === PERFORMANCE_STATIC_PAGE_AB_TEST.new_variation_name;
};
var shouldShowBiggerStorageInPricingFeatures = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cookies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof cookies[USE_OLD_STORAGE_SETTINGS] !== "undefined") {
        return cookies[USE_OLD_STORAGE_SETTINGS] !== "true";
    }
    return getAbTestVariantNew(abTests, BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.test_name, sendBigBrainEvent) === BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.new_variation_name;
};
var shouldSeeDesktopWithEnterpriseMenuAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST.test_name, sendBigBrainEvent) === DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST.new_variation_name;
};
var shouldGetEnterpriseContactUsPageAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST.test_name, sendBigBrainEvent) === PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST.new_variation_name;
};
var shouldGetMobileStickySignupAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, MOBILE_STICKY_SIGNUP_AB_TEST.test_name, sendBigBrainEvent) === MOBILE_STICKY_SIGNUP_AB_TEST.new_variation_name;
};
var shouldGetWelcomeBackPageTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], persistantCookies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, extraBigBrainParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (persistantCookies[WEBSITE_AB_TEST_DEBUG_COOKIE_NAME] === WELCOME_BACK_PAGE_TEST.test_name) return true;
    return getAbTestVariantNew(abTests, WELCOME_BACK_PAGE_TEST.test_name, sendBigBrainEvent, false, extraBigBrainParams) === WELCOME_BACK_PAGE_TEST.new_variation_name;
};
var shouldGetKeepRegionTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cloudfrontViewerCountry = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    try {
        var _localStorage;
        if (isRunningInClient() && ((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem("is_in_keep_region_test")) === "true") {
            return true;
        }
        if (isCountryInContinent(cloudfrontViewerCountry, OCEANIA)) {
            // only people from Oceanic countries should enter the test
            return getAbTestVariantNew(abTests, KEEP_REGION_TEST.test_name, sendBigBrainEvent) === KEEP_REGION_TEST.new_variation_name;
        }
    } catch (error) {
    // nothing to do - just done to protect from crashes
    }
    return false;
};
var shouldGetContactSalesTypeformEmeaTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_TYPEFORM_EMEA.test_name, sendBigBrainEvent) === CONTACT_SALES_TYPEFORM_EMEA.new_variation_name;
};
var shouldGetContactSalesTypeformAnzTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_TYPEFORM_ANZ.test_name, sendBigBrainEvent) === CONTACT_SALES_TYPEFORM_ANZ.new_variation_name;
};
var shouldHaveHeaderWithNewProductsOfferingTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, HEADER_NEW_PRODUCTS_OFFERING_TEST.test_name, sendBigBrainEvent) === HEADER_NEW_PRODUCTS_OFFERING_TEST.new_variation_name;
};
var shouldGetUnlimitedTimeCTATextTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST.test_name, sendBigBrainEvent) === UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST.new_variation_name;
};
var shouldShowSuccessStoriesInHeaderTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, SHOW_SUCCESS_STORIES_IN_HEADER_TEST.test_name, sendBigBrainEvent) === SHOW_SUCCESS_STORIES_IN_HEADER_TEST.new_variation_name;
};
var shouldGetMobileSoftSignupTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, MOBILE_SOFT_SIGNUP_TEST.test_name, sendBigBrainEvent) === MOBILE_SOFT_SIGNUP_TEST.new_variation_name;
};
var shouldUseNewTypeformVariant = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST.test_name, sendBigBrainEvent) === TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST.new_variation_name;
};
var shouldHaveStudioProductInHeaderTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, STUDIO_IN_HEADER_TEST.test_name, sendBigBrainEvent) === STUDIO_IN_HEADER_TEST.new_variation_name;
};
var shouldHaveEnhancedProductsInHeaderTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, ENHANCED_PRODUCTS_IN_HEADER_TEST.test_name, sendBigBrainEvent) === ENHANCED_PRODUCTS_IN_HEADER_TEST.new_variation_name;
};
var shouldGetWMHighIntentExperience = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, WM_HIGH_INTENT_EXPERIENCE.test_name, sendBigBrainEvent) === WM_HIGH_INTENT_EXPERIENCE.new_variation_name;
};
var shouldGetContactSalesStickyButtonExperience = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_STICKY_BUTTON_EXPERIENCE.test_name, sendBigBrainEvent) === CONTACT_SALES_STICKY_BUTTON_EXPERIENCE.new_variation_name;
};
var shouldGetProminantContactSalesInExistingUsersHeader = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, EXISTING_USERS_HEADER_PROMINANT_CONTACT_SALES_TEST.test_name, sendBigBrainEvent) === EXISTING_USERS_HEADER_PROMINANT_CONTACT_SALES_TEST.new_variation_name;
};
var shouldGetContactSalesWebsitePagesNewUsersTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, PROMINENT_CONTACT_SALES_IN_NEW_USERS_WEBSITE_PAGES_HEADER.test_name, sendBigBrainEvent) === PROMINENT_CONTACT_SALES_IN_NEW_USERS_WEBSITE_PAGES_HEADER.new_variation_name;
};
var shouldGetCrmRemoveSalesTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CRM_REMOVE_SALES_TEST.test_name, sendBigBrainEvent) === CRM_REMOVE_SALES_TEST.new_variation_name;
};
var shouldGetTalkToSalesInWebsiteHeader = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, TALK_TO_SALES_TEST.test_name, sendBigBrainEvent) === TALK_TO_SALES_TEST.new_variation_name;
};
var shouldGetContactSalesInTheFooter = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_FOOTER_TEST.test_name, sendBigBrainEvent) === CONTACT_SALES_FOOTER_TEST.new_variation_name;
};
module.exports = {
    shouldGetSkipSignUpStepInPricingAbTest: shouldGetSkipSignUpStepInPricingAbTest,
    shouldSeeExitPopupSurveyAbTest: shouldSeeExitPopupSurveyAbTest,
    shouldSeeReviveExitPopupAbTest: shouldSeeReviveExitPopupAbTest,
    shouldSeeStaticPagePerformanceAbTest: shouldSeeStaticPagePerformanceAbTest,
    shouldShowBiggerStorageInPricingFeatures: shouldShowBiggerStorageInPricingFeatures,
    shouldSeeDesktopWithEnterpriseMenuAbTest: shouldSeeDesktopWithEnterpriseMenuAbTest,
    shouldGetEnterpriseContactUsPageAbTest: shouldGetEnterpriseContactUsPageAbTest,
    shouldGetMobileStickySignupAbTest: shouldGetMobileStickySignupAbTest,
    shouldGetWelcomeBackPageTest: shouldGetWelcomeBackPageTest,
    shouldGetKeepRegionTest: shouldGetKeepRegionTest,
    shouldGetContactSalesTypeformEmeaTest: shouldGetContactSalesTypeformEmeaTest,
    shouldGetContactSalesTypeformAnzTest: shouldGetContactSalesTypeformAnzTest,
    shouldHaveHeaderWithNewProductsOfferingTest: shouldHaveHeaderWithNewProductsOfferingTest,
    shouldGetUnlimitedTimeCTATextTest: shouldGetUnlimitedTimeCTATextTest,
    shouldShowSuccessStoriesInHeaderTest: shouldShowSuccessStoriesInHeaderTest,
    shouldGetMobileSoftSignupTest: shouldGetMobileSoftSignupTest,
    shouldUseNewTypeformVariant: shouldUseNewTypeformVariant,
    shouldHaveStudioProductInHeaderTest: shouldHaveStudioProductInHeaderTest,
    shouldHaveEnhancedProductsInHeaderTest: shouldHaveEnhancedProductsInHeaderTest,
    shouldGetWMHighIntentExperience: shouldGetWMHighIntentExperience,
    shouldGetContactSalesStickyButtonExperience: shouldGetContactSalesStickyButtonExperience,
    shouldGetProminantContactSalesInExistingUsersHeader: shouldGetProminantContactSalesInExistingUsersHeader,
    shouldGetContactSalesWebsitePagesNewUsersTest: shouldGetContactSalesWebsitePagesNewUsersTest,
    shouldGetCrmRemoveSalesTest: shouldGetCrmRemoveSalesTest,
    shouldGetTalkToSalesInWebsiteHeader: shouldGetTalkToSalesInWebsiteHeader,
    shouldGetContactSalesInTheFooter: shouldGetContactSalesInTheFooter
};


/***/ }),

/***/ 25866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Is": function() { return /* binding */ getClustersConfig; },
  "jw": function() { return /* binding */ getProductByClustersIds; },
  "cd": function() { return /* binding */ parsePageLoadClusters; },
  "PH": function() { return /* binding */ setClusterForUser; },
  "lc": function() { return /* binding */ setClusterIdIfNeeded; },
  "aC": function() { return /* binding */ updateUserClustersListWithMultipleClusters; },
  "lR": function() { return /* binding */ updateUserClustersListWithSingleCluster; }
});

// UNUSED EXPORTS: getClusterIdsFromLastTagsSelection, getCurrentClusters

// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./constants/cookies.js
var constants_cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./constants/localstorage.js
var localstorage = __webpack_require__(50663);
// EXTERNAL MODULE: ./constants/query-params.js
var query_params = __webpack_require__(54224);
// EXTERNAL MODULE: ./constants/clusters/sources.js
var sources = __webpack_require__(5792);
// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
// EXTERNAL MODULE: ./server/services/bigbrain-tracking-service/bigbrain-tracking-service.js
var bigbrain_tracking_service = __webpack_require__(75422);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
;// CONCATENATED MODULE: ./server/services/data-service/providers/cluster-config-data-provider.js





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var trackBigBrainEventOnServer = (__webpack_require__(75422).trackBigBrainEventOnServer);
var BaseDataProvider = (__webpack_require__(73645).BaseDataProvider);
var ProviderKeys = __webpack_require__(15071);
var CLUSTER_INTERNAL_FETCH_ERROR = (__webpack_require__(65023).CLUSTER_INTERNAL_FETCH_ERROR);
var REFRESH_INTERVAL_MINUTES = 15 * 60;
var URL_BASE = "https://monday.com";
var CLUSTER_CONFIG_URL_BASE = "".concat(URL_BASE, "/clusters/get-cluster-config");
var ClusterConfigDataProvider = /*#__PURE__*/ function(BaseDataProvider) {
    "use strict";
    (0,_inherits/* default */.Z)(ClusterConfigDataProvider, BaseDataProvider);
    var _super = (0,_create_super/* default */.Z)(ClusterConfigDataProvider);
    function ClusterConfigDataProvider(params) {
        (0,_class_call_check/* default */.Z)(this, ClusterConfigDataProvider);
        return _super.call(this, params);
    }
    (0,_create_class/* default */.Z)(ClusterConfigDataProvider, [
        {
            key: "key",
            value: function key() {
                var ref = this.params(), clusterId = ref.clusterId, subClusterId = ref.subClusterId, locale = ref.locale;
                return "".concat(ProviderKeys.CLUSTER_CONFIG, "_cluster_").concat(clusterId, "_subCluster_").concat(subClusterId, "_locale_").concat(locale);
            }
        },
        {
            key: "refreshInterval",
            value: function refreshInterval() {
                return REFRESH_INTERVAL_MINUTES;
            }
        },
        {
            key: "getData",
            value: function getData() {
                var _this = this;
                return _async_to_generator(function() {
                    var ref, clusterId, subClusterId, locale, options, searchParams, url, res, response, e;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ref = _this.params(), clusterId = ref.clusterId, subClusterId = ref.subClusterId, locale = ref.locale;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                options = {
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    method: "GET"
                                };
                                searchParams = new URLSearchParams({
                                    clusterId: clusterId,
                                    subClusterId: subClusterId,
                                    locale: locale
                                });
                                url = "".concat(CLUSTER_CONFIG_URL_BASE, "?").concat(searchParams);
                                return [
                                    4,
                                    fetch(url, options)
                                ];
                            case 2:
                                res = _state.sent();
                                if (!((res === null || res === void 0 ? void 0 : res.status) === 200)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    res.json()
                                ];
                            case 3:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                            case 4:
                                throw new Error(res.statusText);
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                trackBigBrainEventOnServer(CLUSTER_INTERNAL_FETCH_ERROR, {
                                    direct_object: e.message
                                });
                                console.error(e.message);
                                throw e;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ClusterConfigDataProvider;
}(BaseDataProvider);
/* harmony default export */ var cluster_config_data_provider = (ClusterConfigDataProvider);

// EXTERNAL MODULE: ./server/services/data-service/providers/base-data-provider.js
var base_data_provider = __webpack_require__(73645);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./services/utils-service.js
var utils_service = __webpack_require__(20618);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var lodash_orderBy = __webpack_require__(75472);
;// CONCATENATED MODULE: ./services/clusters-service.js

function clusters_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function clusters_service_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                clusters_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                clusters_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

















var MAX_CLUSTERS = 10;
var DEFAULT_HOMEPAGE_SOURCE = "na_hp";
var OPERATIONS = {
    ADDED: "added",
    UPDATED: "updated",
    NOTHING: "nothing",
    ADDED_AND_REMOVED: "added_and_removed"
};
//* *********************************  LEGACY UTM CLUSTER AND SUBCLUSTER COOKIE SUPPORT  *************************************************************** */
// Keeping support for old utm_cluster_id and utm_sub_cluster_id_cookies - will become obsolete eventually - Platform and Bigrain will use only data points
var setFinalClusterIdAndTrackEventIfNeeded = function(clusterId, reason, options) {
    (0,cookies_service/* setCookie */.d8)(constants_cookies.CLUSTER_COOKIE, clusterId);
    (0,bigbrain_service.setUtmClusterId)(clusterId);
    if (options.sendBigBrainEvent) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SET_CLUSTER_ID_EVENT_NAME, {
            kind: clusterId,
            info1: reason,
            info2: window.location.href
        });
    }
};
var setFinalSubClusterIdAndTrackEventIfNeeded = function(subClusterId, reason, options) {
    if (subClusterId) {
        (0,cookies_service/* setCookie */.d8)(constants_cookies.SUB_CLUSTER_COOKIE, subClusterId);
    }
    if (!subClusterId && (0,cookies_service/* getCookie */.ej)(constants_cookies.SUB_CLUSTER_COOKIE)) {
        //	removing the cookie so we won't have sub cluster of another cluster
        (0,cookies_service/* removeCookie */.nJ)(constants_cookies.SUB_CLUSTER_COOKIE);
    }
    (0,bigbrain_service.setUtmSubClusterId)(subClusterId);
    if (options.sendBigBrainEvent) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SET_SUB_CLUSTER_ID_EVENT_NAME, {
            kind: subClusterId,
            info1: reason,
            info2: window.location.href
        });
    }
};
var setClusterIdIfNeeded = function(configClusterId, subClusterId) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var clusterReason = options.reason || sources/* SET_CLUSTER_FROM_PAGE_CONFIG_REASON */.Dj;
    if (configClusterId) {
        setFinalClusterIdAndTrackEventIfNeeded(configClusterId, clusterReason, options);
        setFinalSubClusterIdAndTrackEventIfNeeded(subClusterId, clusterReason, options); //	setting if having, or clearing if not
    }
};
//* ********************************* END OF LEGACY UTM CLUSTER AND SUBCLUSTER COOKIE SUPPORT  *************************************************************** */
// ---------------------------------------------- //
// -----  MULTIPLE CLUSTERS ON LOCAL STORAGE ---- //
// ---------------------------------------------- //
var shouldSetClusterToUser = function(source) {
    //  if the source is cookie, we won't log, as it was logged already
    return ![
        sources/* HP_COOKIE */.ar,
        sources/* PLATFORM_COOKIE */.kh
    ].includes(source);
};
var setClusterForUser = function(clusterId, clusterType, clusterSource) {
    var clusterExtraData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    //  todo: should move the utm_cluster_id logic into here
    //   and have a "black box" which will set the "right" cluster cookie for the user,
    //   which will be used on the next page load as default value (see getClusterValueAndSource)
    if (clusterId && shouldSetClusterToUser(clusterSource)) {
        updateUserClustersListWithSingleCluster(clusterId, clusterType, clusterSource, {
            clusterExtraData: clusterExtraData
        });
    }
};
// TODO: ASK Etay - can we keep this functions as is with the subCluster param etc.. ? there is a lot of code depending on it.
var getClusterInfoForCurrentSession = function(overrideParams, cookies, pageConfig, options) {
    // for making things simpler for now, subclusters must have cluster with them (in param/page config/etc...)
    var clusterId, subClusterId, clusterIdSource, subClusterIdSource;
    var isPricingPage = options.pricingPage; // platform cookies is relevant only for pricing page, and pricing page doesn't use page config
    if (overrideParams[query_params.CLUSTER]) {
        clusterId = overrideParams[query_params.CLUSTER];
        subClusterId = overrideParams[query_params.SUB_CLUSTER];
        clusterIdSource = sources/* PARAM */.xf;
        subClusterIdSource = subClusterId && sources/* PARAM */.xf;
    } else if (isPricingPage && cookies[constants_cookies.PLATFORM_ACCOUNT_CLUSTER_COOKIE]) {
        clusterId = cookies[constants_cookies.PLATFORM_ACCOUNT_CLUSTER_COOKIE];
        subClusterId = cookies[constants_cookies.PLATFORM_ACCOUNT_SUB_CLUSTER_COOKIE];
        clusterIdSource = sources/* PLATFORM_COOKIE */.kh;
        subClusterIdSource = subClusterId && sources/* PLATFORM_COOKIE */.kh;
    } else if (!isPricingPage && pageConfig.clusterId) {
        clusterId = pageConfig.clusterId;
        subClusterId = pageConfig.subClusterId;
        clusterIdSource = sources/* PAGE_CONFIG */.ZD;
        subClusterIdSource = subClusterId && sources/* PAGE_CONFIG */.ZD;
    } else {
        clusterId = cookies[constants_cookies.CLUSTER_COOKIE];
        subClusterId = cookies[constants_cookies.SUB_CLUSTER_COOKIE];
        clusterIdSource = clusterId && sources/* HP_COOKIE */.ar;
        subClusterIdSource = subClusterId && sources/* HP_COOKIE */.ar;
    }
    return {
        clusterId: clusterId,
        subClusterId: subClusterId,
        clusterIdSource: clusterIdSource,
        subClusterIdSource: subClusterIdSource
    };
};
var parsePageLoadClusters = function(overrideParams, cookies, pageConfig) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return getClusterInfoForCurrentSession(overrideParams, cookies, pageConfig, options);
};
var createCluster = function(param) {
    var clusterId = param.clusterId, clusterType = param.clusterType, attributionTime = param.attributionTime, _source = param.source, source = _source === void 0 ? DEFAULT_HOMEPAGE_SOURCE : _source, _extraData = param.extraData, extraData = _extraData === void 0 ? {} : _extraData;
    return _object_spread({
        cluster_id: clusterId,
        type: clusterType,
        source: source,
        attribution_time: attributionTime,
        last_seen: attributionTime
    }, extraData);
};
var getIndexOfClusterIfExists = function(clustersOfUser, newCluster) {
    var indexOfClusterIfExists = null;
    clustersOfUser.some(function(e, index) {
        if (e.cluster_id === newCluster.cluster_id && e.type === newCluster.type && e.source === newCluster.source) {
            indexOfClusterIfExists = index;
            return true;
        }
    });
    return indexOfClusterIfExists;
};
var addOrUpdateClustersIfNeeded = function(param) {
    var clustersOfUser = param.clustersOfUser, newCluster = param.newCluster, attributionTime = param.attributionTime;
    var indexOfClusterIfExists = getIndexOfClusterIfExists(clustersOfUser, newCluster);
    if (indexOfClusterIfExists !== null) {
        clustersOfUser[indexOfClusterIfExists].last_seen = attributionTime;
        return OPERATIONS.UPDATED;
    }
    clustersOfUser.push(newCluster);
    if (clustersOfUser.length > MAX_CLUSTERS) {
        // removeOldestEntry(clustersOfUser); // following up first
        return OPERATIONS.ADDED_AND_REMOVED;
    }
    return OPERATIONS.ADDED;
};
var getCurrentClusters = function() {
    try {
        return JSON.parse(localStorage.getItem(localstorage.CLUSTERS)) || [];
    } catch (e) {
        return [];
    }
};
var saveClusters = function(clustersOfUser) {
    localStorage.setItem(localstorage.CLUSTERS, JSON.stringify(clustersOfUser));
};
var updateCluster = function(param) {
    var clustersOfUser = param.clustersOfUser, clusterId = param.clusterId, clusterType = param.clusterType, attributionTime = param.attributionTime, source = param.source, _extraData = param.extraData, extraData = _extraData === void 0 ? {} : _extraData;
    if (!clusterId) return;
    var newCluster = createCluster({
        clusterId: clusterId,
        clusterType: clusterType,
        attributionTime: attributionTime,
        source: source,
        extraData: extraData
    });
    var operationStatus = addOrUpdateClustersIfNeeded({
        clustersOfUser: clustersOfUser,
        newCluster: newCluster,
        attributionTime: attributionTime
    });
    (0,bigbrain_service.trackEvent)(bigbrain_event_types.SET_CLUSTER_EVENT, {
        kind: operationStatus,
        info1: clusterId,
        info2: clusterType,
        info3: location.href,
        placement: source,
        data: JSON.stringify(extraData)
    });
};
var updateUserClustersListWithMultipleClusters = function(clusters, source) {
    var clustersOfUser = getCurrentClusters();
    var attributionTime = new Date().getTime();
    clusters.forEach(function(cluster) {
        var clusterId = cluster.clusterId, clusterType = cluster.clusterType, extraData = cluster.extraData;
        updateCluster({
            clustersOfUser: clustersOfUser,
            clusterId: clusterId,
            clusterType: clusterType,
            attributionTime: attributionTime,
            source: source,
            extraData: extraData
        });
    });
    saveClusters(clustersOfUser);
};
var updateUserClustersListWithSingleCluster = function(clusterId, clusterType, source) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var clusterExtraData = options.clusterExtraData, setSignupCluster = options.setSignupCluster, useCaseId = options.useCaseId, restOptions = _object_without_properties(options, [
        "clusterExtraData",
        "setSignupCluster",
        "useCaseId"
    ]);
    var clusters = [
        {
            clusterId: clusterId,
            clusterType: clusterType,
            extraData: clusterExtraData
        }
    ];
    if (useCaseId) {
        clusters.push({
            clusterId: useCaseId,
            clusterType: types.USE_CASE_TYPE,
            extraData: _object_spread_props(_object_spread({}, clusterExtraData), {
                parent_cluster_id: clusterId
            })
        });
    }
    updateUserClustersListWithMultipleClusters(clusters, source);
    if (clusterType === types.CLUSTER_TYPE && setSignupCluster) {
        setClusterIdIfNeeded(clusterId, useCaseId, restOptions);
    }
};
var getClustersConfig = function() {
    var _ref = clusters_service_async_to_generator(function(clusterId, subClusterId, locale) {
        var clusterConfig, provider, exception;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    clusterConfig = {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    provider = new cluster_config_data_provider({
                        clusterId: clusterId,
                        subClusterId: subClusterId,
                        locale: locale
                    });
                    return [
                        4,
                        (0,base_data_provider.getCachedData)(provider)
                    ];
                case 2:
                    clusterConfig = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    exception = _state.sent();
                    (0,bigbrain_tracking_service.trackBigBrainEventOnServer)(bigbrain_event_types.CLUSTER_INTERNAL_ERROR, {
                        info1: exception.message,
                        info2: locale,
                        info3: clusterId,
                        direct_object_id: subClusterId
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        clusterConfig
                    ];
            }
        });
    });
    return function getClustersConfig(clusterId, subClusterId, locale) {
        return _ref.apply(this, arguments);
    };
}();
var getClusterIdsFromLastTagsSelection = function(clusters) {
    var clustersFromTags = clusters.filter(function(cluster) {
        return cluster.source === HP_TAGS_SELECTION;
    });
    var lastAttributedCluster = orderBy(clustersFromTags, [
        "last_seen"
    ], [
        "desc"
    ])[0];
    var lastAttributedClusters = clustersFromTags.filter(function(cluster) {
        return cluster.last_seen === lastAttributedCluster.last_seen;
    });
    return lastAttributedClusters.map(function(cluster) {
        return cluster.cluster_id;
    });
};
var getProductByClustersIds = function(clustersIds) {
    // no selection or 'More workflows' is selected ('More workflows' is not assigned with a cluster)
    if (clustersIds.length === 0) {
        return null;
    }
    // all clusters that do not exist in the map, map to work management
    var productsIds = (0,utils_service.newUniqueArray)(clustersIds.map(function(clusterId) {
        return products/* clusterIdToProductIdMap */.xr[clusterId] || products/* WORK_MANAGEMENT_PRODUCT_ID */.py;
    }));
    // selection maps to a single product
    if (productsIds.length === 1) {
        return productsIds[0];
    }
    // selection maps to multiple products - return 'Work management'
    return products/* WORK_MANAGEMENT_PRODUCT_ID */.py;
};


/***/ }),

/***/ 40927:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
var _cloudinaryAssetQualities = __webpack_require__(65832);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var SHA256 = __webpack_require__(52153);
var CLOUDINARY_CLOUD_NAME = "dapulse";
var CLOUDINARY_BASE = "https://dapulse-res.cloudinary.com/";
var CLOUDINARY_UNSECURE_BASE = "http://dapulse-res.cloudinary.com/";
var CLOUDINARY_STATIC_FOLDER = "remote_mondaycom_static";
var CLOUDINARY_IMAGE_DIRECTORY = "image/";
var CLOUDINARY_VIDEO_DIRECTORY = "video/";
var CLOUDINARY_STATIC_FOLDER_NAME = "/static";
var GENERATOR_FEATURED_IMAGES_FOLDER = "Generator_featured images";
var CLOUDINARY_MEDIA_LIBRARY_USER_NAME = "eranh@monday.com";
var CLOUDINARY_MEDIA_LIBRARY_SCRIPT = "https://media-library.cloudinary.com/global/all.js";
var CLOUDINARY_BASE_VIDEO_URL = "".concat(CLOUDINARY_STATIC_FOLDER, "/video/video-library");
var CLOUDINARY_VIDEO_RESOURCE = "video";
var CLOUDINARY_IMAGE_UPLOADS_BASE_FOLDER = "".concat(CLOUDINARY_STATIC_FOLDER, "/uploads");
var CLOUDINARY_IMAGE_RESOURCE = "image";
var CLOUDINARY_IMAGE_PREFIX = "".concat(CLOUDINARY_BASE).concat(CLOUDINARY_IMAGE_DIRECTORY);
var CLOUDINARY_VIDEO_PREFIX = "".concat(CLOUDINARY_BASE).concat(CLOUDINARY_VIDEO_DIRECTORY);
var LOW_RES_IMAGE_QUALITY_LEVEL = 1;
var IMAGE_DEFAULT_BLUR = 300;
var CLOUDINARY_IMAGE_FILE_TYPE = "IMAGE";
var CLOUDINARY_VIDEO_FILE_TYPE = "VIDEO";
var CLOUDINARY_GIF_FILE_TYPE = "GIF";
var CLOUDINARY_VIDEO_THUMBNAIL_FILE_TYPE = "VIDEO_THUMBNAIL";
var GIF_FILE_EXTENSION = "gif";
var JPG_FILE_EXTENSION = "jpg";
var GIF_TO_VIDEO_AUTO_TRANSFORMATION = "f_mp4,f_auto";
var VIDEO_THUMBNAIL_TRANSFORMATION = "so_0p";
var FALLBACK_DEFAULT_IMAGE_TRANSFORMATION_PARAM = "d";
var addBasePathToUrl = (__webpack_require__(932).addBasePathToUrl);
var ref = __webpack_require__(14688), getFileExtension = ref.getFileExtension, replaceFileExtension = ref.replaceFileExtension;
var PRODUCTION_CLOUDINARY_STATIC_FOLDER = "remote_mondaycom_static";
var STAGING_CLOUDINARY_STATIC_FOLDER = "remote_mondaystagingcom_static";
// Holds auto upload mappings configured in cloudinary account for use to migrate images to cloudinary from s3 buckets
var AutoUploadMappings = {
    "https://monday.com/static": PRODUCTION_CLOUDINARY_STATIC_FOLDER,
    "https://monday.com/Generator_featured images": GENERATOR_FEATURED_IMAGES_FOLDER,
    "https://mondaystaging.com/Generator_featured images": GENERATOR_FEATURED_IMAGES_FOLDER,
    "https://mondaystaging.com/static": STAGING_CLOUDINARY_STATIC_FOLDER
};
var AutoUploadMappingsKeys = Object.keys(AutoUploadMappings);
var defaultTransformationParams = {
    crop: "fill",
    gravity: "faces"
};
// For creating the url
var PresetKeysConvertion = {
    width: "w_",
    height: "h_",
    crop: "c_",
    gravity: "g_",
    aspectRatio: "ar_",
    radius: "r_",
    quality: "q_",
    blur: "e_blur:",
    raw: "raw",
    defaultImage: "d_"
};
var PresetKeysConvertionKey = Object.keys(PresetKeysConvertion);
// These presets are pre made by cloudinary and does not require any additional calculation (on-the-fly calculations)
// If changed - make sure to update the upload presets (both production and staging) in cloudinary account
var PresetTransformations = {
    SMALL_CARD: _object_spread({
        width: 328,
        height: 225
    }, defaultTransformationParams),
    FEATURE_CARD: _object_spread({
        aspectRatio: "704:410",
        width: 704,
        height: 410
    }, defaultTransformationParams),
    SMALL: _object_spread({
        width: 128
    }, defaultTransformationParams),
    MEDUIM: _object_spread({
        width: 256
    }, defaultTransformationParams),
    LARGE: _object_spread({
        width: 512
    }, defaultTransformationParams),
    XLARGE: _object_spread({
        width: 1024
    }, defaultTransformationParams),
    XXLARGE: _object_spread({
        width: 2048
    }, defaultTransformationParams),
    SMALL_ROUND: _object_spread({
        radius: "max",
        width: 128,
        height: 128
    }, defaultTransformationParams),
    TEMPLATE_COVER: _object_spread({
        aspectRatio: "1766:768"
    }, defaultTransformationParams)
};
var extractPublicId = function(src) {
    if (!src) {
        return {
            publicId: src
        };
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // checking if src is mapped in cloudinary for auto upload
        for(var _iterator = AutoUploadMappingsKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (src.startsWith(key)) {
                // this url is for auto upload
                var id = src.substring(key.length);
                var newUrl = "".concat(AutoUploadMappings[key]).concat(id);
                return {
                    publicId: newUrl
                };
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        isFetch: true,
        publicId: src
    }; // other urls that are not auto uploaded
};
var getCloudinaryMethodPostfix = function(isFetch) {
    return isFetch ? "fetch/" : "upload/";
};
var generateCloudinaryRawUrl = function(src) {
    var fixedSrc = addBasePathToUrl(src);
    var ref = extractPublicId(fixedSrc), isFetch = ref.isFetch, publicId = ref.publicId;
    var postfix = getCloudinaryMethodPostfix(isFetch);
    return "".concat(CLOUDINARY_BASE, "raw/").concat(postfix).concat(publicId);
};
var getPrefix = function(fileType) {
    switch(fileType){
        case CLOUDINARY_IMAGE_FILE_TYPE:
        case CLOUDINARY_GIF_FILE_TYPE:
            return CLOUDINARY_IMAGE_PREFIX;
        case CLOUDINARY_VIDEO_FILE_TYPE:
        case CLOUDINARY_VIDEO_THUMBNAIL_FILE_TYPE:
            return CLOUDINARY_VIDEO_PREFIX;
        default:
            return CLOUDINARY_IMAGE_PREFIX;
    }
};
var getImageTransformation = function(assetQuality) {
    return "f_auto,".concat(assetQuality);
};
var getVideoTransformation = function(assetQuality) {
    return "".concat(assetQuality, ",f_auto,cs_copy");
}; // reversed the order to clear cache with monday 2.0 video issue
var getTransformation = function(param) {
    var fileType = param.fileType, assetQuality = param.assetQuality;
    assetQuality = assetQuality || _cloudinaryAssetQualities.AUTO;
    switch(fileType){
        case CLOUDINARY_IMAGE_FILE_TYPE:
            return getImageTransformation(assetQuality);
        case CLOUDINARY_VIDEO_FILE_TYPE:
            return getVideoTransformation(assetQuality);
        case CLOUDINARY_GIF_FILE_TYPE:
            return GIF_TO_VIDEO_AUTO_TRANSFORMATION;
        case CLOUDINARY_VIDEO_THUMBNAIL_FILE_TYPE:
            return VIDEO_THUMBNAIL_TRANSFORMATION;
        default:
            return getImageTransformation(assetQuality);
    }
};
var getPresets = function(transformation, preset) {
    if (!preset) return transformation;
    var transformations = [
        transformation
    ];
    PresetKeysConvertionKey.forEach(function(key) {
        if (preset[key]) {
            transformations.push("".concat(PresetKeysConvertion[key]).concat(preset[key]));
        }
    });
    return transformations.join(",");
};
var generateCloudinaryUrl = function(fileType, publicId, isFetch, preset) {
    var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    var assetQuality = options.assetQuality;
    var prefix = getPrefix(fileType);
    var postfix = getCloudinaryMethodPostfix(isFetch);
    var transformation = getTransformation({
        fileType: fileType,
        assetQuality: assetQuality
    });
    var presets = getPresets(transformation, preset);
    var cloudinaryUrl = "".concat(prefix).concat(postfix).concat(presets, "/").concat(publicId);
    return cloudinaryUrl;
};
var extractWidthTransformationIfNeeded = function(props, cloudinaryTransformations) {
    var width = props.width;
    if (!width) return cloudinaryTransformations;
    if (typeof width === "number") {
        cloudinaryTransformations.width = width;
    } else if (typeof width === "string" && width.indexOf("px") > -1) {
        cloudinaryTransformations.width = parseInt(width);
    }
    return cloudinaryTransformations;
};
var extractCloudinaryTransformations = function() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var cloudinaryTransformations = {};
    cloudinaryTransformations = extractWidthTransformationIfNeeded(props, cloudinaryTransformations);
    return cloudinaryTransformations;
};
var generateCloudinaryImageUrl = function(src) {
    var cloudinaryTransformations = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var fixedSrc = addBasePathToUrl(src);
    var ref = extractPublicId(fixedSrc), isFetch = ref.isFetch, publicId = ref.publicId;
    return generateCloudinaryUrl(CLOUDINARY_IMAGE_FILE_TYPE, publicId, isFetch, cloudinaryTransformations, options);
};
var getCloudinaryUrlSrc = function(src) {
    return isCloudinaryUrl(src) ? src : generateCloudinaryImageUrl(src);
};
var generateCloudinaryVideoThumbnail = function(videoSrc) {
    var fixedSrc = addBasePathToUrl(videoSrc);
    var fileWithImageExtension = replaceFileExtension(fixedSrc, JPG_FILE_EXTENSION);
    var ref = extractPublicId(fileWithImageExtension), isFetch = ref.isFetch, publicId = ref.publicId;
    return generateCloudinaryUrl(CLOUDINARY_VIDEO_THUMBNAIL_FILE_TYPE, publicId, isFetch, null);
};
var generateCloudinaryVideoUrl = function(src) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fixedSrc = addBasePathToUrl(src);
    var ref = extractPublicId(fixedSrc), isFetch = ref.isFetch, publicId = ref.publicId;
    var fileType = getFileExtension(src) === GIF_FILE_EXTENSION ? CLOUDINARY_GIF_FILE_TYPE : CLOUDINARY_VIDEO_FILE_TYPE;
    return generateCloudinaryUrl(fileType, publicId, isFetch, null, options);
};
var getPropValueFromCloudinaryUrl = function(cloudinaryFullUrl) {
    if (!cloudinaryFullUrl) return;
    var cloudinaryDecodedUrl = decodeURIComponent(cloudinaryFullUrl);
    var staticFolderPrefix = cloudinaryDecodedUrl.indexOf(CLOUDINARY_STATIC_FOLDER);
    if (staticFolderPrefix > -1) {
        var splitStr = cloudinaryDecodedUrl.substring(staticFolderPrefix + CLOUDINARY_STATIC_FOLDER.length);
        return "".concat(CLOUDINARY_STATIC_FOLDER_NAME).concat(splitStr);
    }
    var featuredImagesFolderPrefix = cloudinaryDecodedUrl.indexOf(GENERATOR_FEATURED_IMAGES_FOLDER);
    if (featuredImagesFolderPrefix > -1) {
        return "/".concat(cloudinaryDecodedUrl.substring(featuredImagesFolderPrefix));
    }
    return cloudinaryFullUrl;
};
var getFolderValueFromCloudinaryUrl = function(cloudinaryFullUrl) {
    if (!cloudinaryFullUrl) return;
    var cloudinaryDecodedUrl = decodeURIComponent(cloudinaryFullUrl).replace("http:", "https:");
    var prefixUrl = "".concat(CLOUDINARY_BASE, "image/upload/");
    var relativeUrl = cloudinaryDecodedUrl.indexOf(prefixUrl);
    if (relativeUrl > -1) {
        var relativeFolder = cloudinaryDecodedUrl.substring(prefixUrl.length, cloudinaryDecodedUrl.lastIndexOf("/"));
        return relativeFolder.substring(relativeFolder.indexOf("/") + 1, relativeFolder.length); // remove the v[number] folder path
    }
    return null;
};
var getCloudinaryMediaLibraryAuthenticationAccess = function() {
    var _ref = _async_to_generator(function() {
        var get, ref, CLOUDINARY_API_KEY, CLOUDINARY_API_SECRET, timeStamp, userName, authString, signature, apiKey;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    get = (__webpack_require__(61217).get);
                    return [
                        4,
                        get("cloudinary")
                    ];
                case 1:
                    ref = _state.sent(), CLOUDINARY_API_KEY = ref.api_key, CLOUDINARY_API_SECRET = ref.api_secret;
                    timeStamp = Math.round(new Date().getTime() / 1000);
                    userName = CLOUDINARY_MEDIA_LIBRARY_USER_NAME;
                    authString = "cloud_name=".concat(CLOUDINARY_CLOUD_NAME, "&timestamp=").concat(timeStamp, "&username=").concat(userName).concat(CLOUDINARY_API_SECRET);
                    signature = SHA256(authString).toString();
                    apiKey = CLOUDINARY_API_KEY;
                    return [
                        2,
                        {
                            timeStamp: timeStamp,
                            signature: signature,
                            userName: userName,
                            apiKey: apiKey
                        }
                    ];
            }
        });
    });
    return function getCloudinaryMediaLibraryAuthenticationAccess() {
        return _ref.apply(this, arguments);
    };
}();
var getMediaLibraryCreationConfig = function(cloudinaryAuthentication) {
    return {
        cloud_name: CLOUDINARY_CLOUD_NAME,
        api_key: cloudinaryAuthentication === null || cloudinaryAuthentication === void 0 ? void 0 : cloudinaryAuthentication.apiKey,
        username: cloudinaryAuthentication === null || cloudinaryAuthentication === void 0 ? void 0 : cloudinaryAuthentication.userName,
        insert_caption: "Select",
        timestamp: cloudinaryAuthentication === null || cloudinaryAuthentication === void 0 ? void 0 : cloudinaryAuthentication.timeStamp,
        signature: cloudinaryAuthentication === null || cloudinaryAuthentication === void 0 ? void 0 : cloudinaryAuthentication.signature,
        multiple: false
    };
};
var isCloudinaryUrl = function(url) {
    return (url === null || url === void 0 ? void 0 : url.indexOf(CLOUDINARY_BASE)) === 0 || (url === null || url === void 0 ? void 0 : url.indexOf(CLOUDINARY_UNSECURE_BASE)) === 0;
};
var getColorTransformation = function(color) {
    if (!color) return null;
    // if color doesn't start with a pound sign (although should) -
    // return an empty string that would not affect the Cloudinary url
    if (color.charAt(0) !== "#") {
        return null;
    }
    // remove pound sound from color
    var colorWithNoPoundSign = color.substring(1);
    return "e_colorize,co_rgb:".concat(colorWithNoPoundSign, "/");
};
/* DON'T USE THIS FUNCTION
 * It's currently used for a specific use case, and will be fixed later so it can be used by any component
 * */ var getUrlWithColor = function(param) {
    var url = param.url, color = param.color;
    var cloudinaryDecodedUrl = decodeURIComponent(url);
    var colorString = getColorTransformation(color);
    // if failed to create the color transformation
    if (!colorString) {
        return url;
    }
    var insertPosition = cloudinaryDecodedUrl.indexOf(GENERATOR_FEATURED_IMAGES_FOLDER);
    var urlWithColor = [
        cloudinaryDecodedUrl.slice(0, insertPosition),
        colorString,
        cloudinaryDecodedUrl.slice(insertPosition)
    ].join("");
    return urlWithColor;
};
module.exports = {
    CLOUDINARY_CLOUD_NAME: CLOUDINARY_CLOUD_NAME,
    LOW_RES_IMAGE_QUALITY_LEVEL: LOW_RES_IMAGE_QUALITY_LEVEL,
    IMAGE_DEFAULT_BLUR: IMAGE_DEFAULT_BLUR,
    CLOUDINARY_IMAGE_FILE_TYPE: CLOUDINARY_IMAGE_FILE_TYPE,
    PresetTransformations: PresetTransformations,
    extractPublicId: extractPublicId,
    generateCloudinaryUrl: generateCloudinaryUrl,
    generateCloudinaryImageUrl: generateCloudinaryImageUrl,
    generateCloudinaryVideoUrl: generateCloudinaryVideoUrl,
    generateCloudinaryRawUrl: generateCloudinaryRawUrl,
    generateCloudinaryVideoThumbnail: generateCloudinaryVideoThumbnail,
    extractCloudinaryTransformations: extractCloudinaryTransformations,
    CLOUDINARY_STATIC_FOLDER: CLOUDINARY_STATIC_FOLDER,
    CLOUDINARY_BASE_VIDEO_URL: CLOUDINARY_BASE_VIDEO_URL,
    CLOUDINARY_IMAGE_UPLOADS_BASE_FOLDER: CLOUDINARY_IMAGE_UPLOADS_BASE_FOLDER,
    getPropValueFromCloudinaryUrl: getPropValueFromCloudinaryUrl,
    getFolderValueFromCloudinaryUrl: getFolderValueFromCloudinaryUrl,
    getCloudinaryMediaLibraryAuthenticationAccess: getCloudinaryMediaLibraryAuthenticationAccess,
    CLOUDINARY_MEDIA_LIBRARY_SCRIPT: CLOUDINARY_MEDIA_LIBRARY_SCRIPT,
    CLOUDINARY_VIDEO_RESOURCE: CLOUDINARY_VIDEO_RESOURCE,
    CLOUDINARY_IMAGE_RESOURCE: CLOUDINARY_IMAGE_RESOURCE,
    getMediaLibraryCreationConfig: getMediaLibraryCreationConfig,
    isCloudinaryUrl: isCloudinaryUrl,
    CLOUDINARY_IMAGE_PREFIX: CLOUDINARY_IMAGE_PREFIX,
    FALLBACK_DEFAULT_IMAGE_TRANSFORMATION_PARAM: FALLBACK_DEFAULT_IMAGE_TRANSFORMATION_PARAM,
    getCloudinaryUrlSrc: getCloudinaryUrlSrc,
    getUrlWithColor: getUrlWithColor
};


/***/ }),

/***/ 932:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);

var COMMUNITY_URL_PREFIX = "";
var isDevelopment = process.env.ENV == "DEV";
var MONDAY_STORIES_SLUG_URL = "https://mondaystories.monday.com";
var getTemplateUrl = function(templateId) {
    if (!templateId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/show/").concat(templateId);
};
var getTemplateUrlWithNextTemplates = function(templateId, nextTemplatesIds) {
    if (!templateId) {
        return null;
    }
    if (!nextTemplatesIds || nextTemplatesIds.length == 0) {
        return getTemplateUrl(templateId);
    }
    return "".concat(getTemplateUrl(templateId), "?next=").concat(nextTemplatesIds.join());
};
var getTemplateEditUrl = function(templateId) {
    if (!templateId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/edit/").concat(templateId);
};
var getTemplateEditSelfie = function(templateId) {
    if (!templateId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/edit-selfie/").concat(templateId);
};
var getTemplateEditBoardScreenshot = function(templateId) {
    if (!templateId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/edit-board-screenshot/").concat(templateId);
};
var getUserTemplatesUrl = function(userId) {
    if (!userId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/user/").concat(userId);
};
var getAccountTemplatesUrl = function(accountId) {
    if (!accountId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/account/").concat(accountId);
};
var getAdminPageUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/admin");
};
var getTop5CategoryPageUrl = function(category) {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/top5/").concat(category);
};
var getShareNewTemplateUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/new");
};
var getUserPagesUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/user/pages");
};
var getUserApprovalPageUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/user/approval");
};
var isUserPagesUrl = function(url) {
    return url && url.endsWith("/stories/user/pages");
};
var fixDevImageUrl = function(src) {
    if (isDevelopment && src && (src.startsWith("/static/") || src.startsWith("/Generator_featured images"))) {
        // in local host - change the source url to mondaystaging.com
        src = "https://mondaystaging.com" + src;
    }
    return src;
};
var addBasePathToUrl = function(src) {
    src = fixDevImageUrl(src);
    if (src && !src.startsWith("http")) {
        src = "".concat("https://monday.com").concat(src);
    }
    return src;
};
var getIntercomConversationUrl = function(appId, userId) {
    return "https://app.intercom.io/a/apps/".concat(appId, "/users/").concat(userId, "/all-conversations");
};
var getMondayStoriesBoardUrl = function(boardId) {
    return "".concat(MONDAY_STORIES_SLUG_URL, "/boards/").concat(boardId);
};
var getMondayStoriesEmbeddedBoardUrl = function(boardId) {
    return "".concat(MONDAY_STORIES_SLUG_URL, "/embedded_boards_json/").concat(boardId, "?clean-board=true&allow-edit=true");
};
var getMondayBoardUrl = function(boardId, slug) {
    return "".concat(MONDAY_STORIES_SLUG_URL.replace("mondaystories", slug), "/boards/").concat(boardId);
};
var getSlugUseTemplateUrl = function(slug) {
    return MONDAY_STORIES_SLUG_URL.replace("mondaystories", slug) + "/stories/board_from_story";
};
var getHomeUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories");
};
var getLoginUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/authentication/signin");
};
var getSignupUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/signup");
};
var getLandingPageWithoutAutoLoginUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/u_landing");
};
module.exports = {
    getTemplateUrl: getTemplateUrl,
    getTemplateUrlWithNextTemplates: getTemplateUrlWithNextTemplates,
    getTemplateEditUrl: getTemplateEditUrl,
    getUserTemplatesUrl: getUserTemplatesUrl,
    getUserApprovalPageUrl: getUserApprovalPageUrl,
    getAccountTemplatesUrl: getAccountTemplatesUrl,
    getAdminPageUrl: getAdminPageUrl,
    fixDevImageUrl: fixDevImageUrl,
    getShareNewTemplateUrl: getShareNewTemplateUrl,
    getUserPagesUrl: getUserPagesUrl,
    isUserPagesUrl: isUserPagesUrl,
    getTemplateEditSelfie: getTemplateEditSelfie,
    getTemplateEditBoardScreenshot: getTemplateEditBoardScreenshot,
    getIntercomConversationUrl: getIntercomConversationUrl,
    getMondayStoriesBoardUrl: getMondayStoriesBoardUrl,
    getMondayBoardUrl: getMondayBoardUrl,
    getMondayStoriesEmbeddedBoardUrl: getMondayStoriesEmbeddedBoardUrl,
    getSlugUseTemplateUrl: getSlugUseTemplateUrl,
    getHomeUrl: getHomeUrl,
    getLoginUrl: getLoginUrl,
    getSignupUrl: getSignupUrl,
    getLandingPageWithoutAutoLoginUrl: getLandingPageWithoutAutoLoginUrl,
    getTop5CategoryPageUrl: getTop5CategoryPageUrl,
    addBasePathToUrl: addBasePathToUrl
};


/***/ }),

/***/ 85010:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var countriesList = __webpack_require__(53590);
// COUNTRY CODES
var CANADA_ISO2 = "CA";
var ISRAEL_ISO2 = "IL";
var UNITED_STATES_ISO2 = "US";
var MEXICO_ISO2 = "MX";
var SPAIN_ISO2 = "ES";
var PORTUGAL_ISO2 = "PT";
var CHILE_ISO2 = "CL";
var PERO_ISO2 = "PE";
var ARGENTINA_ISO2 = "AR";
var BRAZIL_ISO2 = "BR";
var FRANCE_ISO2 = "FR";
var BELGIUM_ISO2 = "BE";
var GERMANY_ISO2 = "DE";
var AUSTRIA_ISO2 = "AT";
var SWITZERLAND_ISO2 = "CH";
var NETHERLANDS_ISO2 = "NL";
var ITALY_ISO2 = "IT";
var RUSSIA_ISO2 = "RU";
var JAPAN_ISO2 = "JP";
var KOREA_ISO2 = "KO";
var TURKEY_ISO2 = "TR";
var SWEDEN_ISO2 = "SE";
var BULGARIA_ISO2 = "BG";
var NORWAY_ISO2 = "NO";
var DENMARK_ISO2 = "DK";
var POLAND_ISO2 = "PL";
var LUXEMBOURG_ISO2 = "LU";
var HONG_KONG_ISO2 = "HK";
var ICELAND_ISO2 = "IS";
var TAIWAN_ISO2 = "TW";
var AUSTRALIA_ISO2 = "AU";
var UNITED_KINGDOM_ISO2 = "GB";
var IRELAND_ISO2 = "IE";
var SAUDI_ARABIA_ISO2 = "SA";
var NEW_ZEALAND_ISO2 = "NZ";
var COSTA_RICA_ISO2 = "CR";
var EL_SALVADOR_ISO2 = "SV";
var GUATEMALA_ISO2 = "GT";
var HONDURAS_ISO2 = "HN";
var NICARAGUA_ISO2 = "NI";
var PANAMA_ISO2 = "PA";
var CUBA_ISO2 = "CU";
var DOMINICAN_REPUBLIC_ISO2 = "DO";
var PUERTO_RICO_ISO2 = "PR";
var BOLIVIA_ISO2 = "BO";
var COLUMBIA_ISO2 = "CO";
var ECUADOR_ISO2 = "EC";
var PARAGUAY_ISO2 = "PY";
var PERU_ISO2 = "PE";
var URUGUAY_ISO2 = "UY";
var VENEZUELA_ISO2 = "VE";
var EQUATORIAL_GUINEA_ISO2 = "GQ";
var FINLAND_ISO2 = "FI";
var ARMENIA_ISO2 = "AM";
var AZERBAIJAN_ISO2 = "AZ";
var BAHRAIN_ISO2 = "BH";
var BELARUS_ISO2 = "BY";
var CROATIA_ISO2 = "HR";
var CYPRUS_ISO2 = "CY";
var CZECHIA_ISO2 = "CZ";
var EGYPT_ISO2 = "EG";
var ESTONIA_ISO2 = "EE";
var GEORGIA_ISO2 = "GE";
var GREECE_ISO2 = "GR";
var HUNGARY_ISO2 = "HU";
var KAZAKHSTAN_ISO2 = "KZ";
var KENYA_ISO2 = "KE";
var KUWAIT_ISO2 = "KW";
var LATVIA_ISO2 = "LV";
var LITHUANIA_ISO2 = "LT";
var MAURITIUS_ISO2 = "MU";
var MOZAMBIQUE_ISO2 = "MZ";
var NIGERIA_ISO2 = "NG";
var OMAN_ISO2 = "OM";
var QATAR_ISO2 = "QA";
var ROMANIA_ISO2 = "RO";
var RWANDA_ISO2 = "RW";
var SLOVAKIA_ISO2 = "SK";
var SLOVENIA_ISO2 = "SL";
var SOUTH_AFRICA_ISO2 = "ZA";
var SOUTH_SUDAN_ISO2 = "SS";
var TANZANIA_ISO2 = "TZ";
var UGANDA_ISO2 = "UG";
var UKRAINE_ISO2 = "UA";
var UNITED_ARAB_EMIRATES_ISO2 = "AE";
var UZBEKISTAN_ISO2 = "UZ";
var AMERICAN_SAMOA_ISO2 = "AS";
var GUAM_ISO2 = "GU";
var NORTHERN_MARIANA_ISLANDS_ISO2 = "MP";
var UNITED_STATES_MINOR_OUTLYING_ISLANDS_ISO2 = "UM";
var MAIN_COUNTRY_CODES = {
    CANADA_ISO2: CANADA_ISO2,
    ISRAEL_ISO2: ISRAEL_ISO2,
    UNITED_STATES_ISO2: UNITED_STATES_ISO2,
    MEXICO_ISO2: MEXICO_ISO2,
    SPAIN_ISO2: SPAIN_ISO2,
    PORTUGAL_ISO2: PORTUGAL_ISO2,
    CHILE_ISO2: CHILE_ISO2,
    PERO_ISO2: PERO_ISO2,
    ARGENTINA_ISO2: ARGENTINA_ISO2,
    BRAZIL_ISO2: BRAZIL_ISO2,
    FRANCE_ISO2: FRANCE_ISO2,
    BELGIUM_ISO2: BELGIUM_ISO2,
    GERMANY_ISO2: GERMANY_ISO2,
    AUSTRIA_ISO2: AUSTRIA_ISO2,
    SWITZERLAND_ISO2: SWITZERLAND_ISO2,
    NETHERLANDS_ISO2: NETHERLANDS_ISO2,
    ITALY_ISO2: ITALY_ISO2,
    RUSSIA_ISO2: RUSSIA_ISO2,
    JAPAN_ISO2: JAPAN_ISO2,
    KOREA_ISO2: KOREA_ISO2,
    TURKEY_ISO2: TURKEY_ISO2,
    SWEDEN_ISO2: SWEDEN_ISO2,
    BULGARIA_ISO2: BULGARIA_ISO2,
    NORWAY_ISO2: NORWAY_ISO2,
    DENMARK_ISO2: DENMARK_ISO2,
    POLAND_ISO2: POLAND_ISO2,
    LUXEMBOURG_ISO2: LUXEMBOURG_ISO2,
    HONG_KONG_ISO2: HONG_KONG_ISO2,
    ICELAND_ISO2: ICELAND_ISO2,
    TAIWAN_ISO2: TAIWAN_ISO2,
    AUSTRALIA_ISO2: AUSTRALIA_ISO2,
    UNITED_KINGDOM_ISO2: UNITED_KINGDOM_ISO2,
    IRELAND_ISO2: IRELAND_ISO2,
    SAUDI_ARABIA_ISO2: SAUDI_ARABIA_ISO2,
    NEW_ZEALAND_ISO2: NEW_ZEALAND_ISO2,
    COSTA_RICA_ISO2: COSTA_RICA_ISO2,
    EL_SALVADOR_ISO2: EL_SALVADOR_ISO2,
    GUATEMALA_ISO2: GUATEMALA_ISO2,
    HONDURAS_ISO2: HONDURAS_ISO2,
    NICARAGUA_ISO2: NICARAGUA_ISO2,
    PANAMA_ISO2: PANAMA_ISO2,
    CUBA_ISO2: CUBA_ISO2,
    DOMINICAN_REPUBLIC_ISO2: DOMINICAN_REPUBLIC_ISO2,
    PUERTO_RICO_ISO2: PUERTO_RICO_ISO2,
    BOLIVIA_ISO2: BOLIVIA_ISO2,
    COLUMBIA_ISO2: COLUMBIA_ISO2,
    ECUADOR_ISO2: ECUADOR_ISO2,
    PARAGUAY_ISO2: PARAGUAY_ISO2,
    PERU_ISO2: PERU_ISO2,
    URUGUAY_ISO2: URUGUAY_ISO2,
    VENEZUELA_ISO2: VENEZUELA_ISO2,
    EQUATORIAL_GUINEA_ISO2: EQUATORIAL_GUINEA_ISO2,
    FINLAND_ISO2: FINLAND_ISO2,
    ARMENIA_ISO2: ARMENIA_ISO2,
    AZERBAIJAN_ISO2: AZERBAIJAN_ISO2,
    BAHRAIN_ISO2: BAHRAIN_ISO2,
    BELARUS_ISO2: BELARUS_ISO2,
    CROATIA_ISO2: CROATIA_ISO2,
    CYPRUS_ISO2: CYPRUS_ISO2,
    CZECHIA_ISO2: CZECHIA_ISO2,
    EGYPT_ISO2: EGYPT_ISO2,
    ESTONIA_ISO2: ESTONIA_ISO2,
    GEORGIA_ISO2: GEORGIA_ISO2,
    GREECE_ISO2: GREECE_ISO2,
    HUNGARY_ISO2: HUNGARY_ISO2,
    KAZAKHSTAN_ISO2: KAZAKHSTAN_ISO2,
    KENYA_ISO2: KENYA_ISO2,
    KUWAIT_ISO2: KUWAIT_ISO2,
    LATVIA_ISO2: LATVIA_ISO2,
    LITHUANIA_ISO2: LITHUANIA_ISO2,
    MAURITIUS_ISO2: MAURITIUS_ISO2,
    MOZAMBIQUE_ISO2: MOZAMBIQUE_ISO2,
    NIGERIA_ISO2: NIGERIA_ISO2,
    OMAN_ISO2: OMAN_ISO2,
    QATAR_ISO2: QATAR_ISO2,
    ROMANIA_ISO2: ROMANIA_ISO2,
    RWANDA_ISO2: RWANDA_ISO2,
    SLOVAKIA_ISO2: SLOVAKIA_ISO2,
    SLOVENIA_ISO2: SLOVENIA_ISO2,
    SOUTH_AFRICA_ISO2: SOUTH_AFRICA_ISO2,
    SOUTH_SUDAN_ISO2: SOUTH_SUDAN_ISO2,
    TANZANIA_ISO2: TANZANIA_ISO2,
    UGANDA_ISO2: UGANDA_ISO2,
    UKRAINE_ISO2: UKRAINE_ISO2,
    UNITED_ARAB_EMIRATES_ISO2: UNITED_ARAB_EMIRATES_ISO2,
    UZBEKISTAN_ISO2: UZBEKISTAN_ISO2
};
var NON_NATIVE_ENGLISH_COUNTRIES_ISO2 = [
    MEXICO_ISO2,
    SPAIN_ISO2,
    CHILE_ISO2,
    PERO_ISO2,
    ARGENTINA_ISO2,
    BRAZIL_ISO2,
    FRANCE_ISO2,
    CANADA_ISO2,
    BELGIUM_ISO2,
    GERMANY_ISO2,
    AUSTRIA_ISO2,
    SWITZERLAND_ISO2,
    NETHERLANDS_ISO2,
    ITALY_ISO2,
    RUSSIA_ISO2,
    JAPAN_ISO2,
    KOREA_ISO2,
    TURKEY_ISO2,
    SWEDEN_ISO2,
    POLAND_ISO2,
    HONG_KONG_ISO2,
    TAIWAN_ISO2
];
// CONTINENT CODES
var OCEANIA = "OC"; // Australia, New Zealand + surrounding islands and countries
var EUROPE = "EU";
var NORTH_AMERICA = "NA";
// Special list of countries - US territories in the Oceania continent
var US_OCEANIC_TERRITORIES = [
    AMERICAN_SAMOA_ISO2,
    GUAM_ISO2,
    NORTHERN_MARIANA_ISLANDS_ISO2,
    UNITED_STATES_MINOR_OUTLYING_ISLANDS_ISO2
];
var getCountriesByContinent = function(continentCode) {
    var countries = countriesList.countries;
    var countryCodes = Object.keys(countries);
    return countryCodes.filter(function(cc) {
        return countries[cc].continent === continentCode;
    });
};
var isCountryInContinent = function(countryCode, continentCode) {
    return getCountriesByContinent(continentCode).includes(countryCode);
};
var getContientByCountry = function(countryCode) {
    var _countries_countryCode;
    var countries = countriesList.countries;
    return (_countries_countryCode = countries[countryCode]) === null || _countries_countryCode === void 0 ? void 0 : _countries_countryCode.continent;
};
module.exports = {
    // COUNTRIES ISO2
    MAIN_COUNTRY_CODES: MAIN_COUNTRY_CODES,
    CANADA_ISO2: CANADA_ISO2,
    UNITED_STATES_ISO2: UNITED_STATES_ISO2,
    UNITED_KINGDOM_ISO2: UNITED_KINGDOM_ISO2,
    AUSTRALIA_ISO2: AUSTRALIA_ISO2,
    ISRAEL_ISO2: ISRAEL_ISO2,
    NON_NATIVE_ENGLISH_COUNTRIES_ISO2: NON_NATIVE_ENGLISH_COUNTRIES_ISO2,
    BRAZIL_ISO2: BRAZIL_ISO2,
    SPAIN_ISO2: SPAIN_ISO2,
    PORTUGAL_ISO2: PORTUGAL_ISO2,
    US_OCEANIC_TERRITORIES: US_OCEANIC_TERRITORIES,
    // CONTINENTS
    OCEANIA: OCEANIA,
    EUROPE: EUROPE,
    NORTH_AMERICA: NORTH_AMERICA,
    // FUNCTIONS
    getCountriesByContinent: getCountriesByContinent,
    isCountryInContinent: isCountryInContinent,
    getContientByCountry: getContientByCountry
};


/***/ }),

/***/ 56274:
/***/ (function(module) {


var TESTING_ENV = "test";
var isDevelopment = "production" === "development";
var isTesting = "production" === TESTING_ENV;
module.exports = {
    isDevelopment: isDevelopment,
    isTesting: isTesting
};


/***/ }),

/***/ 41871:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var getCookie = (__webpack_require__(47041).getCookie);
var isDevelopment = (__webpack_require__(56274).isDevelopment);
var isRunningInClient = (__webpack_require__(44566).isRunningInClient);
var AB_TEST_VARIANTS_HEADER = "x-abtest-variants";
var getHasFreeTier = (__webpack_require__(83070).getHasFreeTier);
var getHasStudentPlan = (__webpack_require__(61418).getHasStudentPlan);
var ref = __webpack_require__(13019), HAS_STUDENT_PLAN_INDICATION_COOKIE_NAME = ref.HAS_STUDENT_PLAN_INDICATION_COOKIE_NAME, HAS_FREE_TIER_INDICATION_COOKIE_NAME = ref.HAS_FREE_TIER_INDICATION_COOKIE_NAME;
var ref1 = __webpack_require__(54224), FORCE_PRICING = ref1.FORCE_PRICING, PREVENT_FREE_TIER_PARAM = ref1.PREVENT_FREE_TIER_PARAM;
var SYNTHETIC_TEST_COOKIE_NAME = (__webpack_require__(13019).SYNTHETIC_TEST_COOKIE_NAME);
var getBigBrainEventSentVarName = function(testName) {
    return "bb_event_sent_ab_test_".concat(testName);
};
var testEventSent = function(testName) {
    var eventSentVar = getBigBrainEventSentVarName(testName);
    return !!window[eventSentVar];
};
var setTestEventSent = function(testName) {
    var eventSentVar = getBigBrainEventSentVarName(testName);
    window[eventSentVar] = true;
};
var setHotjarTestVariant = function(testName, testVariant) {
    if (!isRunningInClient) return;
    if (window && !window.hj || !testVariant) return;
    if (window.path !== "/") return; // temp specific code to record only homepage
    var tag = "".concat(testName, "-").concat(testVariant);
    window.hj("trigger", "".concat(tag));
};
// if called in the client, req and res will be undefined.
// This is ok in the case we just want to avoid sending the BigBrain event
// in synthetic tests and this is only relevant for client.
var shouldSkipEnteringTest = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var req = options.req, res = options.res;
    // Synthetic test - skip entering AB test
    return !!getCookie(SYNTHETIC_TEST_COOKIE_NAME, {
        req: req,
        res: res
    });
};
// can be used both in Server and Clients side render - event sent only when in client
var getAbTestVariantNew = function(allAbTests, testName) {
    var sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, sendHotjarEvent = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, extraBigBrainParams = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    if (isRunningInClient() && shouldSkipEnteringTest()) return null;
    var test = allAbTests.filter(function(abTest) {
        return abTest.name === testName;
    })[0];
    if (!test) return null;
    if (sendBigBrainEvent && isRunningInClient() && !testEventSent(testName)) {
        var trackEvent = (__webpack_require__(65488).trackEvent);
        trackEvent(testName, _object_spread({
            ab_test: test.variant
        }, extraBigBrainParams));
        setTestEventSent(testName);
        if (sendHotjarEvent) setHotjarTestVariant(testName, test.variant);
    }
    return test.variant;
};
var fireEventsOnServerRedirectTests = function(allAbTests) {
// THIS FUNCTION IS USED TO SEND BIG BRAIN EVENT WHEN RUNNING SERVER REDIRECT TESTS
// CREATE AN ABTEST WITH exact_pages that include only the original and redirect page and then call:
// getAbTestVariantNew(allAbTests, TEST_NAME, true);
};
var isInTestWithNewVariant = function(abTestData) {
    var abTests = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return getAbTestVariantNew(abTests, abTestData.test_name, sendBigBrainEvent) === abTestData.new_variation_name;
};
var isInTestWithOldVariant = function(abTestData) {
    var abTests = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return getAbTestVariantNew(abTests, abTestData.test_name, sendBigBrainEvent) === abTestData.old_variation_name;
};
var isInTest = function(abTestData) {
    var abTests = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return !!getAbTestVariantNew(abTests, abTestData.test_name, sendBigBrainEvent);
};
var getHasFreeTierByRequest = function(req) {
    if (!req) return false;
    var path = req.path;
    var freeTierForcePrevent = req.query && req.query[PREVENT_FREE_TIER_PARAM];
    var forcePricing = req.query && req.query[FORCE_PRICING];
    var hasFreeTierCookie = req.cookies[HAS_FREE_TIER_INDICATION_COOKIE_NAME];
    var hasStudentPlanCookie = req.cookies[HAS_STUDENT_PLAN_INDICATION_COOKIE_NAME];
    var hasStudentPlan = getHasStudentPlan({
        forcePricing: forcePricing,
        hasStudentPlanCookie: hasStudentPlanCookie
    });
    return getHasFreeTier({
        asPath: path,
        freeTierForcePrevent: freeTierForcePrevent,
        hasStudentPlan: hasStudentPlan,
        hasFreeTierCookie: hasFreeTierCookie
    });
};
var DEV_AB_TESTS = [
    {
        name: "crm_pricing_page_sections_test",
        variant: "new_with_crm_sections"
    },
    {
        name: "contact_sales_submit_notice_ab_test",
        variant: "new_with_submit_notice"
    },
    {
        name: "keep_region_au_ab_test",
        variant: "new_with_keep_region"
    },
    {
        name: "contact_sales_typeform_emea",
        variant: "new_with_typeform"
    },
    {
        name: "contact_sales_typeform_anz",
        variant: "new_with_typeform"
    },
    {
        name: "header_new_products_offering_more_clickable_test",
        variant: "old_header_products_offering"
    },
    {
        name: "pricing_page_sub_title_v2_ab_test",
        variant: "new_pricing_with_sub_title_v2"
    },
    {
        name: "unlimited_time_free_plan_cta_text_test",
        variant: "new_unlimited_time_cta"
    },
    {
        name: "homepage_pricing_enterprise_contact_us_typeform_feature_flag",
        variant: "new_homepage_pricing_enterprise_contact_us_typeform_feature_flag"
    }
];
var getAbTestsFromRequest = function(req) {
    if (isDevelopment) return JSON.stringify(DEV_AB_TESTS);
    return req.headers[AB_TEST_VARIANTS_HEADER];
};
var getAllAbTestsVariantsFromRequest = function(req) {
    var abTestsHeader = req && getAbTestsFromRequest(req);
    if (abTestsHeader) {
        try {
            return JSON.parse(abTestsHeader);
        } catch (err) {
            console.error("Error Parsing AB Test Header string:", abTestsHeader, " with error: ", err);
            return [];
        }
    } else {
        return [];
    }
};
module.exports = {
    getAbTestVariantNew: getAbTestVariantNew,
    fireEventsOnServerRedirectTests: fireEventsOnServerRedirectTests,
    getAllAbTestsVariantsFromRequest: getAllAbTestsVariantsFromRequest,
    isInTest: isInTest,
    isInTestWithNewVariant: isInTestWithNewVariant,
    isInTestWithOldVariant: isInTestWithOldVariant,
    getHasFreeTierByRequest: getHasFreeTierByRequest,
    shouldSkipEnteringTest: shouldSkipEnteringTest
};


/***/ }),

/***/ 83070:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var URL_PREFIXES = (__webpack_require__(16612).URL_PREFIXES);
var startsWith = __webpack_require__(10240);
var getHasFreeTier = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var freeTierForcePrevent = options.freeTierForcePrevent, asPath = options.asPath, hasFreeTierCookie = options.hasFreeTierCookie, hasStudentPlan = options.hasStudentPlan;
    // QS to prevent free tier
    if (freeTierForcePrevent) return false;
    // Student plan is private case of free tier
    if (hasStudentPlan) return true;
    // Free tier landing pages start with /ft/. we want to force free tier for them.
    if (asPath && startsWith(asPath, URL_PREFIXES.FREE_TIER)) return true;
    // Platform indication.
    if (hasFreeTierCookie) return hasFreeTierCookie === "true";
    return true;
};
module.exports = {
    getHasFreeTier: getHasFreeTier
};


/***/ }),

/***/ 61418:
/***/ (function(module) {


var getHasStudentPlan = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var forcePricing = options.forcePricing, hasStudentPlanCookie = options.hasStudentPlanCookie;
    // Enable us to force the student plan by query param.
    if (forcePricing === "student_plan") return true;
    // Platform indication.
    return hasStudentPlanCookie === "true";
};
module.exports = {
    getHasStudentPlan: getHasStudentPlan
};


/***/ }),

/***/ 20618:
/***/ (function(module, exports, __webpack_require__) {

// Returns the objects that leftArr contains and rightArr doesn't (i.e. leftArr - rightArr )

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
var getArraysDifference = function(leftArr, rightArr) {
    if (isEmpty(leftArr)) {
        return [];
    }
    if (isEmpty(rightArr)) {
        return leftArr.slice(); // clone
    }
    var difference = leftArr.filter(function(x) {
        return rightArr.indexOf(x) == -1;
    });
    return difference;
};
// returns a random integer between 0 and max (exclusive)
var getRandomInt = function(max) {
    return Math.floor(Math.random() * Math.floor(max));
};
// shuffles array in place
var shuffleArrayInPlace = function(array) {
    for(var i = array.length - 1; i > 0; i--){
        var j = getRandomInt(i + 1);
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
};
/**
 * returns the nested object according to the key
 * i.e. obj = { outer: {inner: 3}}, key = "outer.inner" => return 3, key="other.inner" => return undefined
 * @param {Object} obj
 * @param {String} key
 */ var getNestedObject = function getNestedObject(obj, key) {
    return key.split(".").reduce(function(nested, currentKey) {
        return typeof nested == "undefined" || nested === null ? nested : nested[currentKey];
    }, obj);
};
/**
 * return true if the given object is empty (empty string / empty array / empty object / null / undefined)
 * @param {*} data
 */ var isEmpty = function(data) {
    if (typeof data == "number" || typeof data == "boolean") {
        return false;
    }
    if (typeof data == "undefined" || data === null) {
        return true;
    }
    if (typeof data.length != "undefined") {
        return data.length == 0;
    }
    for(var i in data){
        if (data.hasOwnProperty(i)) {
            return false;
        }
    }
    return true;
};
var UUID_LENGTH = 36;
var isUUID = function(str) {
    var regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return !!str.match(regex);
};
var sleep = function(milliseconds) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, milliseconds);
    });
};
var isFunction = function(value) {
    return typeof value === "function";
};
var mapValuesAsync = function(obj, asyncFn) {
    var keys = Object.keys(obj);
    var promises = keys.map(function(k) {
        return asyncFn(obj[k]).then(function(newValue) {
            return {
                key: k,
                value: newValue
            };
        });
    });
    return Promise.all(promises).then(function(values) {
        var newObj = {};
        values.forEach(function(v) {
            newObj[v.key] = v.value;
        });
        return newObj;
    });
};
var newUniqueArray = function(array) {
    return _toConsumableArray(new Set(array));
};
module.exports = {
    getArraysDifference: getArraysDifference,
    getRandomInt: getRandomInt,
    isEmpty: isEmpty,
    getNestedObject: getNestedObject,
    isUUID: isUUID,
    UUID_LENGTH: UUID_LENGTH,
    sleep: sleep,
    isFunction: isFunction,
    mapValuesAsync: mapValuesAsync,
    newUniqueArray: newUniqueArray,
    shuffleArrayInPlace: shuffleArrayInPlace
};


/***/ }),

/***/ 34955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ isAndroid; },
/* harmony export */   "f5": function() { return /* binding */ appendUrlSchemeIfNeeded; },
/* harmony export */   "pN": function() { return /* binding */ isMeta; },
/* harmony export */   "tq": function() { return /* binding */ isMobile; }
/* harmony export */ });
/* unused harmony exports isFacebook, isInstagram */
/* harmony import */ var services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76127);
/* harmony import */ var services_user_agent_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__);

var isAndroid = function(userAgentParam) {
    var userAgent = userAgentParam || (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.fetchUserAgent)();
    return (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.isAndroidViewer)(userAgent);
};
var isMobile = function(userAgentParam) {
    var userAgent = userAgentParam || (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.fetchUserAgent)();
    return (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.isMobileOrTabletViewer)(userAgent);
};
var isFacebook = function(userAgentParam) {
    var userAgent = userAgentParam || (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.fetchUserAgent)();
    return (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.isFacebookViewer)(userAgent);
};
var isInstagram = function(userAgentParam) {
    var userAgent = userAgentParam || (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.fetchUserAgent)();
    return (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.isInstagramViewer)(userAgent);
};
var isMeta = function(userAgentParam) {
    return isFacebook(userAgentParam) || isInstagram(userAgentParam);
};
var appendUrlSchemeIfNeeded = function(url) {
    var urlScheme = "";
    var urlSuffix = "";
    // https://stackoverflow.com/questions/64934340/google-sign-in-not-working-in-facebook-in-app-browser
    // force open in external browser
    if (isMeta() && isAndroid()) {
        urlScheme = "intent:https:";
        urlSuffix = "#Intent;end";
    }
    return "".concat(urlScheme).concat(url).concat(urlSuffix);
};


/***/ })

}]);